import { call, put, takeLatest } from 'redux-saga/effects';
import { API } from '../api';
import { FETCH_USER_GROUP_PRICING, CREATE_USER_GROUP_PRICING, DELETE_USER_GROUP_PRICING, UPDATE_USER_GROUP_PRICING, GET_USER_GROUP_PRICING } from 'actions/userGroupPricing';

function* fetchUserGroupPricing(action) {
  try {
    const response = yield call(API.getUserGroupPricing, action.payload);
    yield put({ type: FETCH_USER_GROUP_PRICING.SUCCESS, payload: response.data });
    action.cb && action.cb(response);
  } catch (e) {
    yield put({ type: FETCH_USER_GROUP_PRICING.FAIL, payload: { error: e } });
  }
}

function* getUserGroupPricing(action) {
  try {
    const response = yield call(API.getUserGroupPricingById, action.payload);
    yield put({ type: GET_USER_GROUP_PRICING.SUCCESS, payload: response.data });
  } catch (e) {
    yield put({ type: GET_USER_GROUP_PRICING.FAIL, payload: { error: e } });
  }
}

function* createUserGroupPricing(action) {
  try {
    const response = yield call(API.addUserGroupPricing, action.payload);
    yield put({ type: CREATE_USER_GROUP_PRICING.SUCCESS, payload: response.data });
    action.cb && action.cb(response);
  } catch (e) {
    yield put({ type: CREATE_USER_GROUP_PRICING.FAIL, payload: { error: e } });
    action.cb && action.cb(e);
  }
}

function* updateUserGroupPricing(action) {
  try {
    const response = yield call(API.updateUserGroupPricing, action.payload);
    yield put({ type: UPDATE_USER_GROUP_PRICING.SUCCESS, payload: response.data });
    action.cb && action.cb(response);
  } catch (e) {
    yield put({ type: UPDATE_USER_GROUP_PRICING.FAIL, payload: { error: e } });
    action.cb && action.cb(e);
  }
}

function* deleteUserGroupPricing(action) {
  try {
    const response = yield call(API.deleteUserGroupPricing, action.payload);
    yield put({ type: DELETE_USER_GROUP_PRICING.SUCCESS, payload: action.payload });
    action.cb && action.cb(response);
  } catch (e) {
    yield put({ type: DELETE_USER_GROUP_PRICING.FAIL, payload: { error: e } });
    action.cb && action.cb(e);
  }
}

function* userGroupPricing() {
  yield takeLatest(FETCH_USER_GROUP_PRICING.REQUEST, fetchUserGroupPricing);
  yield takeLatest(GET_USER_GROUP_PRICING.REQUEST, getUserGroupPricing);
  yield takeLatest(CREATE_USER_GROUP_PRICING.REQUEST, createUserGroupPricing);
  yield takeLatest(UPDATE_USER_GROUP_PRICING.REQUEST, updateUserGroupPricing);
  yield takeLatest(DELETE_USER_GROUP_PRICING.REQUEST, deleteUserGroupPricing);
}
export default userGroupPricing;
